module.exports = __webpack_public_path__ + "img/13_27.686f894f.png";